'use client';
var classes = {"input":"m_468e7eda"};

export { classes as default };
//# sourceMappingURL=TimeInput.module.css.mjs.map
